/**
 * Light-content guards (docs/PERF.md "Per-world content split"): render the children only once the drawing's (or the
 * lesson's) world chunk is hydrated; a quiet placeholder until then (the chunk loads on mount).
 */
import type { ReactNode } from 'react';
import type { Drawing } from '@sketchling/core';
import { useDrawingReady } from '../lib/content';

export function WhenDrawingReady({ drawing, children, fallback }: { drawing: Drawing; children: () => ReactNode; fallback?: ReactNode }) {
  const ok = useDrawingReady(drawing);
  return <>{ok ? children() : (fallback ?? <span className="thumb thumb-ph" aria-hidden />)}</>;
}
